<div class="gauge"><vue-gauge></vue-gauge></div>